var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCandlestick = function SvgCandlestick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#candlestick_svg__a)",
    fillRule: "evenodd",
    d: "M3.25 3.25V1h1.5v2.25h1.5v9.5h-1.5V19h-1.5v-6.25h-1.5v-9.5zm1.5 1.5h-1.5v6.5h1.5zm4.5 7.5h-1.5v5.5h1.5V19h1.5v-1.25h1.5v-5.5h-1.5V1h-1.5zm0 4h1.5v-2.5h-1.5zm6-12V1h1.5v3.25h1.5v11.5h-1.5V19h-1.5v-3.25h-1.5V4.25zm1.5 1.5h-1.5v8.5h1.5z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "candlestick_svg__a",
    x1: 18.25,
    x2: 1.75,
    y1: 1.75,
    y2: 18.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgCandlestick as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMy4yNSAzLjI1TDMuMjUgMUg0Ljc1VjMuMjVINi4yNVYxMi43NUg0Ljc1TDQuNzUgMTlIMy4yNUwzLjI1IDEyLjc1SDEuNzVWMy4yNUgzLjI1Wk00Ljc1IDQuNzVIMy4yNVYxMS4yNUg0Ljc1VjQuNzVaTTkuMjUgMTIuMjVINy43NUw3Ljc1IDE3Ljc1SDkuMjVMOS4yNSAxOUgxMC43NVYxNy43NUgxMi4yNVYxMi4yNUgxMC43NUwxMC43NSAxSDkuMjVMOS4yNSAxMi4yNVpNOS4yNSAxNi4yNUgxMC43NVYxMy43NUg5LjI1TDkuMjUgMTYuMjVaTTE1LjI1IDQuMjVWMUgxNi43NVY0LjI1SDE4LjI1VjE1Ljc1SDE2Ljc1VjE5SDE1LjI1VjE1Ljc1SDEzLjc1VjQuMjVIMTUuMjVaTTE2Ljc1IDUuNzVIMTUuMjVWMTQuMjVIMTYuNzVWNS43NVoiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8zNDY3XzYxNjMyKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzM0NjdfNjE2MzIiIHgxPSIxOC4yNSIgeTE9IjEuNzUiIHgyPSIxLjc1IiB5Mj0iMTguMjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjEyNjMwMiIgc3RvcC1jb2xvcj0iI0ZGNzg4MCIvPgo8c3RvcCBvZmZzZXQ9IjAuMzc0NCIgc3RvcC1jb2xvcj0iIzE1Q0ZFNCIvPgo8c3RvcCBvZmZzZXQ9IjAuNjI1MTU0IiBzdG9wLWNvbG9yPSIjM0JGMkE1Ii8+CjxzdG9wIG9mZnNldD0iMC44NzYzNDgiIHN0b3AtY29sb3I9IiM2Njc1RkYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";